module.exports = __webpack_public_path__ + "static/media/axe-swing.6958cc19.svg";